module.exports = __webpack_public_path__ + "static/media/NFSB08.1f399264.jpg";